<template>
    <div class="route hml_whplt">
        <swiperList :swiperStyle="{padding: '1.29rem .4rem .5rem'}" :setSwiperNumFlag="true">
            <li
            class="routeSlide"
            v-for="(item,index) in allData[firstLevelIndex].dataArr[secondLevelIndex].list"
            :key="index"
            @click="ruralSlideClick(index)"
            >
                <img :src="item.cover">
                <div class="textContent">
                    <h2 class="title">{{ item.title }}</h2>
                    <p>{{ item.addrs }}</p>
                </div>
            </li>
        </swiperList>
    </div>
</template>

<script>

import { createNamespacedHelpers } from "vuex";
let publicData = createNamespacedHelpers("publicData");
export default {
    data() { 
        return {

        }
    },
    methods: {
        ruralSlideClick(index){
            this.setIndex({levelThreeIndex: index});
            this.$router.push("/routerDetails");
        },
        ...publicData.mapMutations(["setIndex"])
    },
    filters: {
        addrs(value){
            if(value){
                let arr = value.replace(/\n/g,"").split("<br />");
                let str = "";
                arr.forEach(item => {
                    if(item.length > 10){
                        str += "—" + item.split("#")[0];
                    }else{

                    }
                });
                return str.replace(/—/,"")
            }
            return "";
        },
    },
    computed: {
        ...publicData.mapState(['allData','firstLevelIndex','secondLevelIndex','levelThreeIndex'])
    }
}
</script>

<style lang="scss" scoped>
.route{
    // padding-top: .92rem;
    .routeSlide{
        width: 100%;
        height: 2.4rem;
        position: relative;
        overflow: hidden;
        border-radius: .1rem;
        box-shadow:0px .13rem .27rem 0px rgba(0, 0, 0, 0.24);
        margin-bottom: .24rem;
        .textContent{
            width: 100%;
            height: 1.8rem;
            position: absolute;
            left: 0;
            bottom: 0;
            padding: .5rem 0 .28rem .3rem;
            background: linear-gradient(rgba(0,0,0,0),rgba(0,0,0,0.5), rgba(0,0,0,0.9));
            padding-left: .42rem;
            padding-top: .67rem;
            h2{
                font-size: .4rem;
                color: #fff;
                font-family: "siyuan";
            }
            p{
                color: #fff;
                font-size: .22rem;
                margin-top: .14rem;
                padding-right: .3rem;
                line-height: .32rem;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                line-clamp: 1;
                -webkit-box-orient: vertical;
            }
        }
    }
}
</style>